import React from 'react';
import styles from './StatCard.module.css';

export default function StatCard({ label, value, delta, icon, tone = 'brand' }) {
  return (
    <div className={[styles.card, styles[tone] || styles.brand].join(' ')}>
      <div className={styles.head}>
        <span className={styles.label}>{label}</span>
        {icon ? <span className={styles.icon}>{icon}</span> : null}
      </div>
      <div className={styles.value}>{value}</div>
      {delta ? <div className={styles.delta}>{delta}</div> : null}
    </div>
  );
}
